import clsx from 'clsx';
import ReactPlayer from 'react-player';
import { useEffect, useRef, useState } from 'react';
import { IconButton } from '../../components/IconButton';
import { Redo } from '@material-ui/icons';
import { VideoToolbarTop } from './VideoToolbarTop';
import BaseReactPlayer from 'react-player/types/base';
import { ReactPlayerProps } from 'react-player/types/lib';
import { Remote } from './Remote';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useScreenOrientation } from '../../hooks/useScreenOrientation';
import { Loading } from '../../components/Loading';

interface Props {
  autoPlay?: boolean;
}

export const VideoPlayer = ({ autoPlay = false }: Props) => {
  const {
    connected,
    isMobile,
    jumpToLive,
    playerEl,
    playerConfig,
    loading,
    onConnected,
    onVideoDrift,
    source,
    updateStatistics,
    disconnect,
  } = useCitrusView();
  const [hlsPlayer, setHlsPlayer] = useState<any>(null);
  const playerRef = useRef<BaseReactPlayer<ReactPlayerProps> | null>(null);
  const [hideRemote, setHideRemote] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const [hovering, setHovering] = useState(false);
  const video = document.getElementById('remote-monitor-wrapper');
  const isLandscape = useScreenOrientation('landscape');

  useEffect(() => {
    document.addEventListener(
      'fullscreenchange',
      () => {
        setFullscreen(Boolean(document.fullscreenElement));
      },
      false
    );
    return () => {
      document.removeEventListener(
        'fullscreenchange',
        () => {
          setFullscreen(Boolean(document.fullscreenElement));
        },
        false
      );
    };
  }, []);

  useEffect(() => {
    if (video && fullscreen) {
      if (video.requestFullscreen) {
        video.requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
      }
      // @ts-ignore
      else if (video.webkitRequestFullscreen) {
        // @ts-ignore
        video.webkitRequestFullscreen();
      }
    }
  }, [fullscreen, video]);

  const renderJumpToLive = () => {
    if (jumpToLive === false) return;
    return (
      <IconButton
        className={clsx(
          'transition-all duration-300 absolute z-50 top-[50%] right-10',
          {
            ['translate-x-10']: jumpToLive,
          }
        )}
        onClick={() => {
          if (playerEl && playerEl.duration)
            playerEl.currentTime = playerEl.duration - 4;
        }}
      >
        <div className="block text-xs p-1">
          <Redo />
          <p>TO LIVE</p>
        </div>
      </IconButton>
    );
  };

  return (
    <div className={clsx('w-full', { 'bg-black': connected })}>
      <div
        id="remote-monitor-wrapper"
        className={clsx('overflow-hidden', {
          ['top-0 left-0 fixed h-screen w-screen z-[9980]']: fullscreen,
          ['relative m-auto w-[50%] h-auto ']: fullscreen === false,
          ['!h-full !w-full']: isMobile,
        })}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        <VideoToolbarTop
          fullscreen={fullscreen}
          hovering={hovering}
          setFullscreen={setFullscreen}
          onUnHideRemote={() => setHideRemote(false)}
        />
        {renderJumpToLive()}
        {loading ? (
          <div className="absolute inset-0 bg-black">
            <Loading text="Loading Source..." />
          </div>
        ) : null}
        <ReactPlayer
          ref={playerRef}
          id="remote-monitor-player"
          style={{
            minHeight: 300,
            background: 'black',
            display: 'flex',
            alignItems: 'center',
          }}
          url={source}
          width={'100%'}
          height={'100%'}
          config={{
            file: {
              attributes: {
                playsInline: true,
                autoPlay: true,
                muted: true,
                controlsList: 'nofullscreen noplaybackrate',
              },
              forceHLS: true,
              // hlsOptions: {
              //   debug: false,
              // },
            },
          }}
          onError={(error, data) => console.log(data)}
          onDuration={(duration) => {
            if (playerRef && playerRef.current && duration > 4) {
              playerRef.current.seekTo(duration - 4);
            }
          }}
          onReady={(player) => {
            onConnected(player.getInternalPlayer() as HTMLVideoElement);
          }}
          onProgress={(state) => {
            onVideoDrift(state.loadedSeconds - state.playedSeconds > 10);
          }}
          {...playerConfig}
        />
        {/*<VideoFooter*/}
        {/*  connected={connected}*/}
        {/*  hideRemote={hideRemote}*/}
        {/*  setHideRemote={setHideRemote}*/}
        {/*  statistics={statistics}*/}
        {/*/>*/}
      </div>
      <Remote
        fullscreen={fullscreen}
        hidden={hideRemote}
        onHide={() => setHideRemote(true)}
      />
    </div>
  );
};
